import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import { BASEURL, dateFormat } from "../constants";

export function removeDecimalIfZero(inputString) {
  let newString = inputString;
  if (inputString.endsWith(".00")) {
    newString = newString.slice(0, -3); // Remove the last 3 characters (".00")
  } 
  if (inputString.includes("-")) {
    newString = "(" + newString.replace("-", "") + ")";
  }
  return newString;
}

export function formatCurrencySign(number) {
  // Use toFixed(2) to round the number to two decimal places
  // Use replace to add commas for thousands
  return "$" + number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const getSeqNo = (subject) => {
  const seqNo = subject?.seqNo;
  if (seqNo === undefined || seqNo === null || seqNo === "") return null;

  const parsedSeqNo = Number(seqNo);
  return Number.isFinite(parsedSeqNo) ? parsedSeqNo : null;
};

const hasSeqNo = (subject) => {
  const seqNo = getSeqNo(subject);
  return seqNo !== null && seqNo > 0;
};

const compareBySeqNo = (a, b) => {
  const aSeqNo = getSeqNo(a);
  const bSeqNo = getSeqNo(b);

  if (aSeqNo > 0 && bSeqNo > 0) return aSeqNo - bSeqNo;
  if (aSeqNo > 0) return -1;
  if (bSeqNo > 0) return 1;

  return compareByStartDate(a, b);
};

const compareByStartDate = (a, b) => {
  const aStartDate = moment(a.startDate, dateFormat, true);
  const bStartDate = moment(b.startDate, dateFormat, true);
  const aHasValidStartDate = aStartDate.isValid();
  const bHasValidStartDate = bStartDate.isValid();

  if (!aHasValidStartDate && !bHasValidStartDate) return 0;
  if (!aHasValidStartDate) return 1;
  if (!bHasValidStartDate) return -1;

  const startDateDiff = aStartDate.valueOf() - bStartDate.valueOf();
  return startDateDiff;
};

export const getSortedSubjects = (subjects) => {
  if (!Array.isArray(subjects) || subjects.length === 0) return subjects;

  const hasAnySeqNo = subjects.some(hasSeqNo);

  return [...subjects].sort(hasAnySeqNo ? compareBySeqNo : compareByStartDate);
};

export const sendOtp = async (studentId, ObjectType = 5) => {
    try {
      const response = await axios.post(`${BASEURL}Login/sendOtp`, {
        StudentId: studentId,
        ObjectType: "5", // 5 = Student
      });

      if (response.data.success) {
        toast.success("OTP sent to your email!");
        return true;
      } else {
        toast.warning("Login successful, but failed to send OTP.");
        return false;
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      toast.warning("Login successful, but failed to send OTP.");
      return false;
    }
};

export const fetchDocuments = async (objectId, objectType) => {
  try {
    const response = await axios.get(
      BASEURL +
        "Document/Objects/" +
        objectId +
        "?objectType=" +
        objectType
    );
    return response.data || [];
  } catch (error) {
    console.log("Error fetching documents:", error);
    return [];
  }
};
